import { all, takeEvery, put } from 'redux-saga/effects'
import { Network } from '@ocean-club/schemas'
import { ErrorCode } from 'decentraland-transactions'
import { toastSaga as baseToastSaga } from '@ocean-club/dapps/dist/modules/toast/sagas'
import { showToast } from '@ocean-club/dapps/dist/modules/toast/actions'
import {
  GrantTokenFailureAction,
  GRANT_TOKEN_FAILURE,
  RevokeTokenFailureAction,
  REVOKE_TOKEN_FAILURE
} from '@ocean-club/dapps/dist/modules/authorization/actions'
import { getChainConfiguration } from '@ocean-club/dapps/dist/lib/chainConfiguration'
import { TransferNFTFailureAction, TRANSFER_NFT_FAILURE } from '../nft/actions'
import {
  CancelOrderFailureAction,
  CANCEL_ORDER_FAILURE,
  CreateOrderFailureAction,
  CREATE_ORDER_FAILURE,
  ExecuteOrderFailureAction,
  EXECUTE_ORDER_FAILURE
} from '../order/actions'
import {
  getMetaTransactionFailureToast,
  getContractAccountFailureToast
} from './toasts'
import {
  isContractAccountError,
  isUserDeniedSignatureError
} from '../transaction/utils'

export function* toastSaga() {
  yield all([baseToastSaga(), customToastSaga()])
}

function* customToastSaga() {
  yield takeEvery(TRANSFER_NFT_FAILURE, handleNFTMetaTransactionFailure)
  yield takeEvery(CREATE_ORDER_FAILURE, handleNFTMetaTransactionFailure)
  yield takeEvery(EXECUTE_ORDER_FAILURE, handleNFTMetaTransactionFailure)
  yield takeEvery(CANCEL_ORDER_FAILURE, handleNFTMetaTransactionFailure)

  yield takeEvery(
    GRANT_TOKEN_FAILURE,
    handleAuthorizationMetaTransactionFailure
  )
  yield takeEvery(
    REVOKE_TOKEN_FAILURE,
    handleAuthorizationMetaTransactionFailure
  )
}

function* handleNFTMetaTransactionFailure(
  action:
    | TransferNFTFailureAction
    | CreateOrderFailureAction
    | ExecuteOrderFailureAction
    | CancelOrderFailureAction
) {
  const { nft, errorCode } = action.payload

  if (nft.network !== Network.TRON) {
    switch (errorCode) {
      case ErrorCode.USER_DENIED:
        // do nothing
        break
      case ErrorCode.CONTRACT_ACCOUNT:
        yield put(showToast(getContractAccountFailureToast()))
        break
      default:
        yield put(showToast(getMetaTransactionFailureToast()))
    }
  }
}

function* handleAuthorizationMetaTransactionFailure(
  action: GrantTokenFailureAction | RevokeTokenFailureAction
) {
  const { authorization, error } = action.payload

  const { network } = getChainConfiguration(authorization.chainId)

  if (network !== Network.TRON && !isUserDeniedSignatureError(error)) {
    if (isContractAccountError(error)) {
      yield put(showToast(getContractAccountFailureToast()))
    } else {
      yield put(showToast(getMetaTransactionFailureToast()))
    }
  }
}
